// @flow
import React from "react";
import _ from "lodash";
import Dropzone from "react-dropzone";
import I18n from "../../../i18n/I18n";
import drag from "../../../images/common/drag.svg";
import Button from "../../common/button/Button";
import CONFIG from "../../../config";
import styles from "./ImportProducts.scss";

type Props = {
    isLoading: boolean,
    success: boolean | string,
    error: boolean | string,
    importOffers: Function,
    closeModal: Function
};

type State = {
    accepted: Array<Object>,
    rejected: Array<Object>,
    newFile: any,
    success: boolean | string,
    error: boolean | string
};

class ImportProducts extends React.Component<Props, State> {
    constructor(props: Object) {
        super(props);
        this.state = {
            accepted: [],
            rejected: [],
            newFile: null,
            success: props.success,
            error: props.error
        };
    }

    componentWillReceiveProps(nextProps: Object) {
        if (!nextProps.isLoading) {
            this.setState({
                success: nextProps.success,
                error: nextProps.error,
                accepted: nextProps.success ? [] : this.state.accepted
            });
        }
    }

    onDrop = (accepted: Array<Object>, rejected: Array<Object>) => {
        this.setState({ accepted, rejected, success: "", error: "" });
    };

    onSubmit() {
        const acc = this.state.accepted;
        if (!_.isEmpty(acc)) {
            const formData = new FormData();
            formData.append("file", acc[0]);
            formData.append("source", "offers");
            if (this.props.fbnAsn) {
                formData.append("id_fbn_asn", this.props.fbnAsn);
            }
            if (this.props.idFbnAsnBatch) {
                formData.append("id_fbn_asn_batch", this.props.idFbnAsnBatch);
            }
            if (this.props.pSkuOpen) {
                this.props.importPSkuUnique(formData);
            } else this.props.importOffers(formData);
        }
    }
    render() {
        const { pSkuOpen, exportPSku, importsType, text } = this.props;
        return (
            <div className={styles.ctr}>
                <div>
                    <h4 className={styles.header}>
                        {importsType === 1 ? I18n.getText("products.import-p-sku-unique") : ''}
                        {importsType === 2 ? I18n.getText("products.import-stock") : ''}
                        {text ? I18n.getText("products.import-heading") : '' }
                    </h4>
                    <p className={styles.sub}>
                        {I18n.getText("products.import-sub1")}
                        &nbsp;
                        {pSkuOpen ? (
                            <a onClick={() => exportPSku()}>
                                {I18n.getText("products.export-p-sku")}
                            </a>
                        ) : (
                            ""
                        )}
                        {this.props.fbnAsn || pSkuOpen ? (
                            ""
                        ) : (
                            <a href={CONFIG.NIS_LINK} target="_blank">
                                {I18n.getText(
                                    "products.import-sub2",
                                    {},
                                    "Download the right format of CSV file."
                                )}
                            </a>
                        )}
                        &nbsp;
                        {I18n.getText(
                            "products.import-sub3",
                            {},
                            "If you may need help on uploading your products, contact seller support"
                        )}
                    </p>
                </div>
                <Dropzone
                    className={styles.dropArea}
                    multiple={false}
                    onDrop={this.onDrop}
                >
                    <div className={styles.wrapper}>
                        <div className={styles.imageCtr}>
                            <img src={drag} alt="upload" />
                        </div>
                        <div className={styles.dragText}>
                            {!_.isEmpty(this.state.accepted)
                                ? I18n.getText(
                                      "products.update-text",
                                      {},
                                      "Update your file."
                                  )
                                : ""}
                            &nbsp;
                            {I18n.getText(
                                "products.drag-text",
                                {},
                                "Drag & Drop Your Excel File"
                            )}
                            <div className={styles.browse}>
                                {I18n.getText(
                                    "products.browse",
                                    {},
                                    "or Browse"
                                )}
                            </div>
                        </div>
                    </div>
                </Dropzone>
                {this.state.accepted.map(f => (
                    <div
                        className={`${styles.accepted} ${
                            this.state.success ? styles.success : ""
                        }`}
                    >
                        {this.state.success ? (
                            <div>
                                {I18n.getText(
                                    "products.imported",
                                    {},
                                    "Imported Successfully"
                                )}
                            </div>
                        ) : (
                            <div>
                                {f.name} - {f.size} bytes
                            </div>
                        )}
                    </div>
                ))}
                {this.state.success ? (
                    <div
                        className={`${styles.accepted} ${
                            this.state.success ? styles.success : ""
                        }`}
                    >
                        <div>
                            {I18n.getText(
                                "products.imported",
                                {},
                                "Imported Successfully"
                            )}
                        </div>
                    </div>
                ) : (
                    ""
                )}

                {this.state.error ? (
                    <div className={styles.rejected}>{this.state.error}</div>
                ) : (
                    ""
                )}
                {this.state.rejected.map(f => (
                    <div className={styles.rejected}>
                        {f.name} - {f.size} bytes
                    </div>
                ))}
                <div className={styles.btnWrapper}>
                    <Button
                        className={styles.btn}
                        variant="transparent"
                        onClick={() => this.props.closeModal()}
                    >
                        {I18n.getText("products.cancel", {}, "Cancel")}
                    </Button>
                    <Button
                        className={styles.btn}
                        onClick={() => this.onSubmit()}
                        disabled={
                            this.props.isLoading ||
                            _.isEmpty(this.state.accepted)
                        }
                    >
                        {this.props.isLoading ? (
                            <div className={styles.loader}>
                                {I18n.getText(
                                    "products.importing",
                                    {},
                                    "Importing.."
                                )}
                            </div>
                        ) : (
                            I18n.getText("products.submit", {}, "Submit")
                        )}
                    </Button>
                </div>
            </div>
        );
    }
}

export default ImportProducts;



// WEBPACK FOOTER //
// ./src/components/products/importProducts/ImportProducts.js